import { Container, Typography, Box } from '@mui/material';

import { Page } from '@larvitu/shared/mui/ui-components';
import { Link } from '@larvitu/shared/next/mui';

import { getLayout } from '../lib/getLayout';
import { getServerTranslations } from '../lib/i18n/getServerTranslations';

import type { AppPage } from '../@types/page';
import type { GetStaticProps } from 'next';


const email = process.env.NEXT_PUBLIC_NODEMAILER_RECEIVERS

const Impressum: AppPage = () => (
  <Page title="Impressum">
    <Container>
      <Typography
        textAlign="center"
        component="h1"
        variant="h2"
        fontWeight="fontWeightBold"
        gutterBottom
        my={4}
      >
        Impressum
      </Typography>

      <Box my={16}>
        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Angaben gemäß § 5 TMG
          </Typography>
          <Typography variant="body1">Dr. med. Götz Geiges</Typography>
          <Typography variant="body1">Lietzenburger Str. 54</Typography>
          <Typography variant="body1">10719 Berlin</Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Kontakt
          </Typography>
          <Typography variant="body1">Tel: 030 - 88 18 59 8</Typography>
          <Typography variant="body1">
            <Link href={`mailto:${email}`}>kontakt@dr-geiges.de</Link>
          </Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Steueridentifikationsnummer
          </Typography>
          <Typography variant="body1">56870021932</Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Aufsichtsbehörde
          </Typography>
          <Typography variant="body1">
            Kassenärztliche Vereinigung Berlin
          </Typography>
          <Typography variant="body1">Masurenallee 6 A</Typography>
          <Typography variant="body1">14057 Berlin</Typography>
          <Typography variant="body1">030 / 31 003-0</Typography>
          <Typography variant="body1">
            <Link href="https://kvbe@kvberlin.de">kvbe@kvberlin.de</Link>
          </Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Berufsbezeichnung:
          </Typography>
          <Typography variant="body1">
            Arzt bzw. Facharzt für Urologie - wurde von den Praxisinhabern in
            der Bundesrepublik Deutschland erworben.
          </Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Zuständige Kammer
          </Typography>
          <Typography variant="body1">Ärztekammer Berlin</Typography>
          <Typography variant="body1">Friedrichstraße 16</Typography>
          <Typography variant="body1">10969 Berlin</Typography>
          <Typography variant="body1">T +49 30 408 06 - 0</Typography>
          <Typography variant="body1">F +49 30 408 06 - 34 99</Typography>
          <Typography variant="body1">
            <Link href="https://kammer@aekb.de">kammer@aekb.de</Link>
          </Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Berufsrechtliche Regelungen
          </Typography>
          <Typography variant="body1">
            Die Berufsordnung ist bei der Ärztekammer Berlin einsehbar. (
            <Link href="https://www.aekb.de/recht/berufsrecht-berufsordnung">
              www.aekb.de/recht/berufsrecht-berufsordnung
            </Link>
            )
          </Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Haftung
          </Typography>
          <Typography variant="body1">
            Die Partner der Sozietät haften nach § 19 BNotO persönlich für
            Amtspflichtverletzungen.
          </Typography>
        </Box>

        <Box my={4}>
          <Typography
            component="h2"
            variant="h4"
            fontWeight="fontWeightBold"
            gutterBottom
          >
            Design/Entwicklung
          </Typography>
          <Typography variant="body1">
            <Link href="https://larvitu.de"> © Larvitu</Link>
          </Typography>
        </Box>
      </Box>
    </Container>
  </Page>
);

Impressum.getLayout = getLayout;

export default Impressum;

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => ({
  props: {
    ...(await getServerTranslations(locale, ['common', 'contact'])),
  },
});
